module.exports = __webpack_public_path__ + "media/images/pic/program-rozwoju-obszarow-wiejskich-f71ddf5081550d90d261335d095d527b.webp";